import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileFrame from '@/components/MobileFrame';
import { Icon, type IconName } from '@/components/Icons';
import { tpl, useT } from '@/lib/i18n';

export default function PrepareScreen() {
    const t = useT();
    const navigate = useNavigate();
    const [agree, setAgree] = useState(false);

    const items: { icon: IconName; title: string; sub: string }[] = [
        { icon: 'id', title: t.prepareKtp, sub: t.prepareKtpSub },
        { icon: 'camera', title: t.prepareDevice, sub: t.prepareDeviceSub },
        { icon: 'eye', title: t.prepareLight, sub: t.prepareLightSub },
        { icon: 'clock', title: t.prepareTime, sub: t.prepareTimeSub },
    ];

    return (
        <MobileFrame
            progress={(2 / 7) * 100}
            showBack
            stepLabel={tpl(t.stepOf, { current: 2, total: 7 })}
        >
            <div
                className="fade-in"
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '8px 24px 28px',
                }}
            >
                <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
                    {t.prepareTitle}
                </h1>
                <p style={{ fontSize: 14, lineHeight: 1.55, color: 'var(--ink-500)', marginBottom: 24 }}>
                    Sebelum memulai, pastikan Anda telah menyiapkan hal berikut.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
                    {items.map((it, i) => (
                        <div
                            key={i}
                            style={{
                                display: 'flex',
                                gap: 14,
                                padding: '12px 4px',
                                borderBottom:
                                    i < items.length - 1 ? '1px solid var(--ink-100)' : 'none',
                            }}
                        >
                            <div
                                style={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: 10,
                                    flexShrink: 0,
                                    background: 'var(--primary-soft)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Icon name={it.icon} size={18} color="var(--primary)" />
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>
                                    {it.title}
                                </div>
                                <div
                                    style={{
                                        fontSize: 12,
                                        lineHeight: 1.4,
                                        color: 'var(--ink-500)',
                                    }}
                                >
                                    {it.sub}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <label
                    style={{
                        display: 'flex',
                        gap: 10,
                        alignItems: 'flex-start',
                        padding: '12px 0',
                        marginTop: 16,
                        cursor: 'pointer',
                    }}
                >
                    <input
                        type="checkbox"
                        checked={agree}
                        onChange={(e) => setAgree(e.target.checked)}
                        style={{ position: 'absolute', opacity: 0 }}
                    />
                    <div
                        style={{
                            width: 20,
                            height: 20,
                            borderRadius: 5,
                            flexShrink: 0,
                            marginTop: 1,
                            border: `2px solid ${agree ? 'var(--primary)' : 'var(--ink-300)'}`,
                            background: agree ? 'var(--primary)' : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.15s',
                        }}
                    >
                        {agree && <Icon name="check" size={12} color="white" strokeWidth={3} />}
                    </div>
                    <span style={{ fontSize: 13, lineHeight: 1.45, color: 'var(--ink-700)' }}>
                        {t.agreeTerms}
                    </span>
                </label>

                <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: '100%', marginTop: 12 }}
                    disabled={!agree}
                    onClick={() => navigate('/onboarding/phone')}
                >
                    {t.continue}
                    <Icon name="arrowRight" size={18} />
                </button>
            </div>
        </MobileFrame>
    );
}
